module.exports = __webpack_public_path__ + "img/hontai_L2538.9e90cd06.png";